// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styling for code blocks */
.custom-code-block {
    border-radius: 0.5rem;
    overflow: hidden;
    background-color: #f9fafb; /* Light background */
    border: 1px solid #d1d5db; /* Light gray border */
  }
  
  /* Styling for the top bar */
  .custom-code-block .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #1f2937; /* Dark gray */
    color: white;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    border-radius: 0.5rem 0.5rem 0 0;
    font-weight: bold;
  }
  
  /* Styling for the copy button */
  .custom-code-block .copy-btn {
    background-color: #4b5563; /* Slightly lighter gray */
    color: white;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    border-radius: 0.25rem;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
  }
  
  .custom-code-block .copy-btn:hover {
    background-color: #6b7280; /* Lighter gray on hover */
  }
  
  /* Code container */
  .custom-code-block pre {
    background-color: rgb(11, 14, 20);
    padding: 0.5rem;
    border-radius: 0 0 0.5rem 0.5rem;
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 0.875rem;
  }
  
  /* Code styling */
  .custom-code-block code {
    font-size: 1rem;
  }
  
  /* Heading Styles */
  .response-block h1 {
    font-size: 2rem;
    font-weight: 700;
    margin: 1.5rem 0 1rem;
    color: #111827;
  }
  
  .response-block h2 {
    font-size: 1.75rem;
    font-weight: 700;
    margin: 1.25rem 0 0.875rem;
    color: #1f2937;
  }
  
  .response-block h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 1rem 0 0.75rem;
    color: #1f2937;
  }
  
  .response-block h4 {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0.875rem 0 0.625rem;
    color: #374151;
  }
  
  .response-block h5 {
    font-size: 1rem;
    font-weight: 600;
    margin: 0.75rem 0 0.5rem;
    color: #4b5563;
  }
  
  .response-block h6 {
    font-size: 0.875rem;
    font-weight: 600;
    margin: 0.5rem 0 0.375rem;
    color: #6b7280;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Threads/response.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB,EAAE,qBAAqB;IAChD,yBAAyB,EAAE,sBAAsB;EACnD;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB,EAAE,cAAc;IACzC,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA,gCAAgC;EAChC;IACE,yBAAyB,EAAE,0BAA0B;IACrD,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,uCAAuC;EACzC;;EAEA;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,mBAAmB;EACnB;IACE,iCAAiC;IACjC,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;EAChB","sourcesContent":["/* General styling for code blocks */\n.custom-code-block {\n    border-radius: 0.5rem;\n    overflow: hidden;\n    background-color: #f9fafb; /* Light background */\n    border: 1px solid #d1d5db; /* Light gray border */\n  }\n  \n  /* Styling for the top bar */\n  .custom-code-block .top-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #1f2937; /* Dark gray */\n    color: white;\n    padding: 0.5rem 1rem;\n    font-size: 0.875rem;\n    border-radius: 0.5rem 0.5rem 0 0;\n    font-weight: bold;\n  }\n  \n  /* Styling for the copy button */\n  .custom-code-block .copy-btn {\n    background-color: #4b5563; /* Slightly lighter gray */\n    color: white;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.75rem;\n    border-radius: 0.25rem;\n    cursor: pointer;\n    transition: background 0.2s ease-in-out;\n  }\n  \n  .custom-code-block .copy-btn:hover {\n    background-color: #6b7280; /* Lighter gray on hover */\n  }\n  \n  /* Code container */\n  .custom-code-block pre {\n    background-color: rgb(11, 14, 20);\n    padding: 0.5rem;\n    border-radius: 0 0 0.5rem 0.5rem;\n    overflow-x: auto;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    font-size: 0.875rem;\n  }\n  \n  /* Code styling */\n  .custom-code-block code {\n    font-size: 1rem;\n  }\n  \n  /* Heading Styles */\n  .response-block h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    margin: 1.5rem 0 1rem;\n    color: #111827;\n  }\n  \n  .response-block h2 {\n    font-size: 1.75rem;\n    font-weight: 700;\n    margin: 1.25rem 0 0.875rem;\n    color: #1f2937;\n  }\n  \n  .response-block h3 {\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin: 1rem 0 0.75rem;\n    color: #1f2937;\n  }\n  \n  .response-block h4 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    margin: 0.875rem 0 0.625rem;\n    color: #374151;\n  }\n  \n  .response-block h5 {\n    font-size: 1rem;\n    font-weight: 600;\n    margin: 0.75rem 0 0.5rem;\n    color: #4b5563;\n  }\n  \n  .response-block h6 {\n    font-size: 0.875rem;\n    font-weight: 600;\n    margin: 0.5rem 0 0.375rem;\n    color: #6b7280;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
